import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AskForLangComponent} from "./ask-for-lang.component";
import {MatLegacyButtonModule as MatButtonModule} from "@angular/material/legacy-button";
import {FuseCardModule} from "../../../@fuse/components/card";
import {MatLegacyProgressSpinnerModule as MatProgressSpinnerModule} from "@angular/material/legacy-progress-spinner";



@NgModule({

  declarations: [
    AskForLangComponent,
  ],
    imports: [
        CommonModule,
        MatButtonModule,
        FuseCardModule,
        MatProgressSpinnerModule
    ],
  exports: [
    AskForLangComponent
  ]
})
export class AskForLangModule { }
